/* global angular, moment */
/**
 * Created by lari on 03/05/2017.
 */

(function () {
  'use strict';
  /**
   * @ngdoc service
   * @name patient.factory:PatientService
   *
   * @description
   *
   */
  angular
    .module('vcclient')
    .factory('Patient', Patient)
    .config(config);
  
  
  config.$inject = ['restmodProvider'];
  
  function config(restmodProvider) {
    restmodProvider.rebase({
      $config: {
        primaryKey: '_id'
      }
    });
  }
  
  
  Patient.$inject = ['restmod'];
  
  function Patient(restmod) {
    return restmod.model('/routes/patients', 'PagedModel', 'DebouncedModel').mix({
      consults: {hasMany: 'Consult'},
      reminders: {hasMany: 'Reminder'},
      // keywords: {hasMany: 'Keywords'},
      // diagnoses: {hasMany: 'Diagnoses'},
      // drugs: {hasMany: 'Drugs'},
      created: {
        init: function () {
          return moment().toISOString();
        }
      },
      active: {init: true},
      test: {init: false},
      log: {init: []},
      primarycontact: {init: {}},
      companydata: {init: {}},
      diagnoses: {init: []},
      deleteddiagnoses: {init: []},
      svref: {init: {}},
      image: {init: '/img/head_male.png'},
      inconsult: {inconsult: false},
      incheckout: {incheckout: false},
      consultstate: {consultstate: ''},
      checkoutstate: {checkoutstate: ''},
      $extend: {
        Model: {
          $searchahead: function (_params) {
            return this.$collection().$decorate({
              'before-request': function (_req) {
                _req.method = 'GET';
                _req.url = '/routes/patients/searchahead';
              }
            }, function () {
              return this.$fetch(_params);
            });
          } // $searchahead
        } // Model
      }// extend
    });
  }
  
}());